export const storefrontAccessToken = '683970b7a0a5a64000079c4fa2099ba6';
export const storefrontAccessTokenDev = 'e5b03b925fd7d8e1b3c60b14c13b06a8';